// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"6a39299dd97d93cf5834","539":"a49ef93e5ed152d2b365","800":"3fcd0d04111db7ffbcea"}[chunkId] + ".bundle.js";
};